import { Card, Space, TablePaginationConfig } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilterValue, SorterResult } from "antd/lib/table/interface";
import { deleteCompanyGroup, getAllCompanyGroups } from "api/companyGroup.api";
import { getDateAndTime } from "utils/utils";
import { notificationController } from "controllers/notificationController";
interface Props {
  companyGroupRefresher: number;
  setGroupId: any;
}
interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}
export const CompanyGroupList: React.FC<Props> = ({
  companyGroupRefresher,
  setGroupId,
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const initialShortingFields = {};

  const [shortingFields, setShortingFields] = useState<any>(null);
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
      pageSizeOptions: [10],
    },
  });

  const onDeleteCompanyGroup = (groupId: any) => {
    setLoading(true);
    deleteCompanyGroup(groupId).then(
      () => {
        setLoading(false);
        fetchData();
        notificationController.success({
          message: "Company group deleted successfully!",
        });
      },
      () => {
        notificationController.error({
          message: "Something went wrong while deleting the company group!",
        });
      }
    );
  };

  const fetchData = () => {
    setLoading(true);
    getAllCompanyGroups("-companies_count").then(({ results, count }) => {
      setData([...results]);
      setLoading(false);
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: count,
        },
      });
    });
  };

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue>,
    sorter: SorterResult<any>
  ) => {
    setShortingFields({
      ...initialShortingFields,
      [sorter.field as any]:
        sorter.order === "ascend" ? "-" + sorter.field : sorter.field,
    });
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  useEffect(() => {
    fetchData();
  }, [tableParams.pagination?.current, shortingFields, companyGroupRefresher]);

  const columns: ColumnsType<any> = [
    {
      title: "Company Group Title",
      dataIndex: "title",
      defaultSortOrder: "descend",
      render: (text, record) => {
        return (
          <>
            <div className="ellipsis-text">{record.title}</div>
          </>
        );
      },
      sorter: true,
    },

    {
      title: "Number",
      dataIndex: "shortlisted_candidates",

      render: (text, record) => record.companies_count,
    },
    {
      title: "Time",
      dataIndex: "created",
      render: (text) => getDateAndTime(text),
      sorter: true,
    },
    {
      title: "",
      render: (val: any, x: any) => {
        return (
          <Space
            size="middle"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteCompanyGroup(val.id);
            }}
          >
            <DeleteOutlined />
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <Card className="mb-10 mr-10 ">
        <Table
          sortDirections={["descend", "ascend", "descend"]}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const target: any = event.target;
                if (
                  target.parentNode.className.includes("discard-click") ||
                  target.parentNode.parentNode.className.includes(
                    "discard-click"
                  )
                ) {
                  return;
                }
                setGroupId(record.id);
              }, // click row
            };
          }}
          columns={columns}
          pagination={tableParams.pagination}
          loading={loading}
          dataSource={data}
          rowKey={(record) => record.id}
          onChange={handleTableChange as any}
        />
      </Card>
    </>
  );
};
